<template>
  <div>
    <main-navigation/>
    <followed-blogs/>
  </div>
</template>

<script>

  import FollowedBlogs from "./FollowedBlogsList";
  import CenteredCard from "../layout/CenteredCard";
  import MainNavigation from "../layout/MainNavigation";

  export default {
    name: "FollowedBlogsPage",
    components: {
      MainNavigation,
      CenteredCard,
      FollowedBlogs
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/FollowedBlogsPage.vue